module.exports = __webpack_public_path__ + "img/img1.f6a4e19d.png";